module.exports = __webpack_public_path__ + "static/media/device-information.e4ae1365.svg";